import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { Grid, Typography } from "@mui/material";
import moment from "moment";

export const renderStatusColorCss = (data: string) => {
  const status = data && data.toLocaleLowerCase();
  let statusColor = {
    color: "#2858d3",
    background: "#fff",
    border: "1px solid #2858d3",
  };
  if (status === "pending") {
    statusColor = {
      color: "#FF8652",
      background: "rgb(255 134 82 / 10%)",
      border: "1px solid #FF8652",
    };
  }
  if (status === "new") {
    statusColor = {
      color: "#2858D3",
      background: "rgba(40, 88, 211, 0.1)",
      border: "1px solid #2858D3",
    };
  }
  if (status === "open") {
    statusColor = {
      color: "#2858D3",
      background: "rgba(40, 88, 211, 0.1)",
      border: "1px solid #2858D3",
    };
  }
  if (status === "resolved") {
    statusColor = {
      color: "#3EB458",
      background: "rgba(62, 180, 88, 0.1)",
      border: "1px solid #3EB458",
    };
  }
  if (status === "in progress") {
    statusColor = {
      color: "#FFA500",
      background: "#ffa5001f",
      border: "1px solid #FFA500",
    };
  }
  if (status === "inprogress") {
    statusColor = {
      color: "#FFA500",
      background: "#ffa5001f",
      border: "1px solid #FFA500",
    };
  }
  if (status === "closed") {
    statusColor = {
      color: "#A0A5B1",
      background: "rgba(160, 165, 177, 0.1)",
      border: "1px solid #A0A5B1",
    };
  }
  return statusColor;
};

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const renderTicketReadmoreDetails = (details: {
  [key: string]: any;
}) => {
  return (
    <>
      {Object.keys(details).map((detailsKey) =>
        details[detailsKey] && typeof details[detailsKey] === "object" ? (
          Object.keys(details[detailsKey]).map((key: string) => (
            <Grid item xs={12} md={4}>
              <Typography className="title-sm1">
                {key === "family" ? "OS" : key}
              </Typography>
              <Typography
                className="info"
                sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
              >
                {details[detailsKey][key] || "-"}
              </Typography>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} md={4}>
            <Typography className="title-sm1">{detailsKey}</Typography>
            <Typography
              className="info"
              sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
            >
              {details[detailsKey] || "-"}
            </Typography>
          </Grid>
        )
      )}
    </>
  );
};

export const getpageType = (pagetype: any) => {
  const page: any = {
    "feedback": "FEEDBACK",
    "tickets": "BUG_REPORT",
    "feature": "FEATURE_REQUEST",
  };
  return page[pagetype];
};
export const getpageTypeForEmail = (pagetype: any) => {
  const page: any = {
    "feedback": "FEEDBACK",
    "tickets": "BUGS",
    "feature": "FEATURE_REQUEST",
  };
  return page[pagetype];
};
export const getpageTypeEmail = (pagetype: any) => {
  const page: any = {
    "feedback": "feedback",
    "tickets": "tickets",
    "feature": "feature",
  };
  return page[pagetype];
};
export const getFirstAndLastLetters = (str: any) => {
  return str[0].toUpperCase() + "" + str[str.length - 1].toUpperCase();
};
export const getPriorityColor = (priority: any) => {
  const color: any = {
    "low": "#0096FF", //blue
    "lowest": "#0096FF", //blue
    "medium": "#FFA500", //orange
    "high": "#FA3F3F", //red
    "highest": "#FA3F3F", //red
  };
  return color[priority];
};
export const statusList = [
  {
    name: "New",
    value: "new",
  },

  {
    name: "In progress",
    value: "inprogress",
  },
  // {
  //   name: "Pending",
  //   value: "pending",
  // },

  {
    name: "Closed",
    value: "closed",
  },
  // {
  //   name: "Resolved",
  //   value: "resolved",
  // },
];

export const validateOpenAIAPIKey = async (
  apiKey: string | undefined
): Promise<boolean> => {
  if (!apiKey) return false;

  try {
    const response = await fetch("https://api.openai.com/v1/models", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiKey}`,
      },
    });

    if (response.ok) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const getStatusRenderLabel = (data: any) => {
  const status: any = {
    "new": "New", //blue
    "open": "Open", //blue
    "closed": "Closed", //orange
    "inprogress": "In progress", //red
  };
  return status[data];
};

export const dateFilterList = [
  {
    label: "Within 1 hour",
    value: "within1Hr",
  },
  {
    label: "Within 4 hours",
    value: "within4Hr",
  },
  {
    label: "Within 8 hours",
    value: "within8Hr",
  },
  {
    label: "Within 24 hours",
    value: "within24Hr",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "This week",
    value: "thisWeek",
  },
  {
    label: "Last 1 week",
    value: "last1Week",
  },
  {
    label: "This month",
    value: "thisMonth",
  },
  {
    label: "Last 1 month",
    value: "last1Month",
  },
  {
    label: "Last 3 months",
    value: "last3Months",
  },
  {
    label: "Last 6 months",
    value: "last6Months",
  },
];

export const getSelectedDateInUtc = (selectedDateFilter: any) => {
  const momentDate = moment();
  const momentUTC = momentDate.valueOf();

  switch (selectedDateFilter.value) {
    case "within1Hr": {
      return {
        startDate: moment(momentUTC).subtract(1, "hours").valueOf(),
        endDate: momentUTC,
      };
    }
    case "within4Hr": {
      return {
        startDate: moment(momentUTC).subtract(4, "hours").valueOf(),
        endDate: momentUTC,
      };
    }
    case "within8Hr": {
      return {
        startDate: moment(momentUTC).subtract(8, "hours").valueOf(),
        endDate: momentUTC,
      };
    }
    case "within24Hr": {
      return {
        startDate: moment(momentUTC).subtract(24, "hours").valueOf(),
        endDate: momentUTC,
      };
    }
    case "today": {
      return {
        startDate: moment(momentUTC).startOf("day").valueOf(),
        endDate: moment(momentUTC).endOf("day").valueOf(),
      };
    }
    case "thisWeek": {
      return {
        startDate: moment(momentUTC).startOf("week").valueOf(),
        endDate: moment(momentUTC).endOf("week").valueOf(),
      };
    }
    case "last1Week": {
      return {
        startDate: moment(momentUTC)
          .subtract(1, "weeks")
          .startOf("day")
          .valueOf(),
        endDate: moment(momentUTC).endOf("day").valueOf(),
      };
    }
    case "thisMonth": {
      return {
        startDate: moment(momentUTC).startOf("month").valueOf(),
        endDate: moment(momentUTC).endOf("month").valueOf(),
      };
    }
    case "last1Month": {
      return {
        startDate: moment(momentUTC)
          .subtract(1, "months")
          .startOf("day")
          .valueOf(),
        endDate: moment(momentUTC).endOf("day").valueOf(),
      };
    }
    case "last3Months": {
      return {
        startDate: moment(momentUTC)
          .subtract(3, "months")
          .startOf("day")
          .valueOf(),
        endDate: moment(momentUTC).endOf("day").valueOf(),
      };
    }
    case "last6Months": {
      return {
        startDate: moment(momentUTC)
          .subtract(6, "months")
          .startOf("day")
          .valueOf(),
        endDate: moment(momentUTC).endOf("day").valueOf(),
      };
    }
    default: {
      return {
        startDate: "",
        endDate: "",
      };
    }
  }
};
